import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"
import {userRetention} from "../apiConfigs"

export const UserRetentionApi = createAsyncThunk(
    'auth/analytics/UserRetentionApi',
    async (requestData, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(userRetention, { params: requestData })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const UserRetentionSlice = createSlice({
    name: 'analytics/UserRetentionApi',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    extraReducers: (builder) => {
        builder.addCase(UserRetentionApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(UserRetentionApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.results
            state.message = action?.payload?.message
            state.total = action?.payload?.count
        })
        builder.addCase(UserRetentionApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const UserRetentionReducer = UserRetentionSlice.reducer